module.exports = __webpack_public_path__ + "static/media/no-wifi-icon.1f242546.svg";